<script setup lang="ts">
import PrimeInputOtp from 'primevue/inputotp'

interface Props {
  modelValue?: string | boolean | null
  length?: number
  disabled?: boolean
  integerOnly?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  modelValue: '',
  length: 6,
  disabled: false,
  integerOnly: true,
})

const emit = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()

function handleUpdate(value: string | boolean | undefined) {
  emit('update:modelValue', String(value ?? ''))
}
</script>

<template>
  <PrimeInputOtp
    :modelValue="props.modelValue ?? ''"
    :length="props.length"
    :disabled="props.disabled"
    :integerOnly="props.integerOnly"
    @update:modelValue="handleUpdate"
  />
</template>
